(function Sidebar($, Adzuki)
{
	"use strict";

	var Sidebar                = {};
	var $expandedHubMenus      = Cookies.get('hub_menus_visibility') || '[]';
	var expanded_hub_menus     = [];
	var $expandedMyShortcuts   = Cookies.get('my_shortcuts_visibility') || 0;
	var expanded_my_shortcuts  = 0;
	var $rightSidebarContentId = $('#sidebar-right-content');
	var $rightSidebarTitleId   = $('#sidebar-right-title');
	var rowSelectedClass       = 'row-selected';

	Sidebar.ajaxCallback = null;

	/**
	 * Often we will be using the right sidebar in conjunction with a pseudo table. A user will client a "row" and the right sidebar will expand with more detail. We want to highlight
	 * the "row" clicked and remove the highlight from the "row" after the sidebar is closed or switched to something else
	 */
	Sidebar.removeRowSelected = function removeRowSelected($parent)
	{
		if ($parent) {
			$parent.find("." + rowSelectedClass).removeClass(rowSelectedClass);
		} else {
			$("." + rowSelectedClass).removeClass(rowSelectedClass);
		}
	};

	/**
	 * When the sidebar is used in conjunction with a table, first remove the highlighted row and set to another row
	 */
	Sidebar.setRowSelected = function setRowSelected($row)
	{
		var $parent = $row.closest('ul');

		this.removeRowSelected($parent);
		$row.addClass(rowSelectedClass);
	};

	/**
	 * Shows or hides the right sidebar
	 * @param  string state "off" of "on"
	 *
	 */
	Sidebar.toggleRightSidebar = function toggleRightSidebar(state)
	{
		var drawerEl = document.getElementById('sidebarRight'),
		    drawer;

		// MEDIA-335: where the right sidebar is a Bootstrap offcanvas (Trip Summary's
		// layout), open and close it through Bootstrap, so it gets its backdrop and
		// Esc, and hand focus back to what opened it. CP Maxx's sidebar is not one
		// and keeps the class toggling below.
		if (drawerEl && drawerEl.classList.contains('offcanvas') && window.bootstrap && window.bootstrap.Offcanvas) {
			drawer = window.bootstrap.Offcanvas.getOrCreateInstance(drawerEl);

			if (state === 'off') {
				drawer.hide();
				this.removeRowSelected();
			} else {
				if (!drawerEl.classList.contains('show')) {
					Sidebar.returnFocusTo = document.activeElement;
				}

				drawer.show();
			}

			return;
		}

		if (state === 'off') {
			$(".content").removeClass('content-shifted-left');
			$(".sidebar-right").removeClass('sidebar-right-show');
			$("#sidebarRight").removeClass('show');
			this.removeRowSelected();
		} else {
			$(".content").addClass('content-shifted-left');
			$(".sidebar-right").addClass('sidebar-right-show');
			$(".sidebar").removeClass('sidebar-show');
			$("#sidebarRight").addClass('show');
		}
	};

	/**
	 * Show a loading animation before content can be placed
	 */
	Sidebar.addLoadingAnimationRight = function addLoadingAnimationRight()
	{
		$rightSidebarContentId.html('<span class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-2x fa-spin"></span>');
	};

	/**
	 * Add content to the right sidebar
	 * @param html   htmlContent  The content you want displayed
	 * @param string formName     The name of the form to be initialized within the htmlContent, if any
	 */
	Sidebar.addContentRight = function addContentRight(htmlContent, formName, title)
	{
		$rightSidebarContentId.html(htmlContent);
		$rightSidebarTitleId.html(title);

		if (formName) {
			Adzuki.Form.initAjaxForm(formName);
		}

		if (Sidebar.ajaxCallback) {
			Sidebar.ajaxCallback();
		}
	};

	/**
	 * Pull content via ajax and place in the right sidebar
	 * @param  string ajaxPath    path to the script which is pulling the data
	 * @param  string formName    The name of the form within the ajax content to be initialized, if any
	 */
	Sidebar.populateRightContentViaAjax = function populateRightContentViaAjax(ajaxPath, formName, title)
	{
		this.addLoadingAnimationRight();

		Adzuki.Ajax.get(ajaxPath)
		.then(function populate(content) {
			Adzuki.Sidebar.addContentRight(content, formName, title);
		}).then(function checkScroll(e) {
			if (
				$rightSidebarContentId.find('.scrollable').length !== 0
				&& $('#sidebar-right-content').height() > $('.sidebar-right-show').height()
			) {
				$('#sidebar-right-scroll-section').removeClass('hidden');
				handleRightSideBarScrollIcon();
			} else {
				$('#sidebar-right-scroll-section').addClass('hidden');
			}
		});
	};

	/**
	 * checks if the parent row of the clicked sidebar trigger is currently flagged on.  If so, hide the sidebar
	 * @param  jQuery Object$row Parent row of the element clicked
	 * @return boolean           true if currently appearing in the sidebar
	 */
	Sidebar.currentlySelected = function currentlySelected($row)
	{
		var output = false;

		// means this one was already clicked and the content for it is currently already appearing in the sidebar, so we should close the sidebar
		if ($row.hasClass(rowSelectedClass)) {
			this.toggleRightSidebar('off');
			output = true;
		}

		return output;
	};

	// MEDIA-335: the hover tooltip of whatever opened the drawer would stay on
	// screen over it. Tooltips are delegated from <body>; close them through their
	// triggers, and remove any whose trigger a re-render has already replaced
	// (Add Reservation's rows), which Bootstrap can no longer reach.
	$(document).on('show.bs.offcanvas shown.bs.offcanvas', '#sidebarRight', function hideTooltips()
	{
		$('[data-toggle^="tooltip"]').tooltip('hide');
		$('body > .tooltip').remove();
	});

	// MEDIA-335: back to the element that opened the drawer, once it has closed
	$(document).on('hidden.bs.offcanvas', '#sidebarRight', function returnFocus()
	{
		var target = Sidebar.returnFocusTo;

		Sidebar.returnFocusTo = null;
		Adzuki.Sidebar.removeRowSelected();

		if (target && document.body.contains(target) && typeof target.focus === 'function') {
			target.focus();

			// Bootstrap shows a tooltip on focus as well as hover, so handing focus
			// back would pop the button's tooltip up again; focus it, without that
			$(target).tooltip('hide');
			window.setTimeout(function hideReturnedTooltip() {
				$(target).tooltip('hide');
				$('body > .tooltip').remove();
			}, 0);
		}
	});

	$(document).ready(function documentReady()
	{
		expanded_hub_menus    = $.parseJSON($expandedHubMenus);
		expanded_my_shortcuts = parseInt($expandedMyShortcuts);

		$("button.sidebar-toggle").click(function sidebarToggle()
		{
			Adzuki.Sidebar.toggleRightSidebar('off');
			$(".sidebar").toggleClass('sidebar-show');
		});

		$(".content").on("click", ".expand-right-sidebar-ajax", function rightSidebarAjax(e)
		{
			var $row      = $(this).closest('.table-row'),
			    ajax_path = $(this).data('url'),
				title     = $(this).data('title'),
			    form_name = $(this).data('form-name') || null;

			e.preventDefault();

			if (Adzuki.Sidebar.currentlySelected($row)) {
				Adzuki.Sidebar.populateRightContentViaAjax(ajax_path, form_name, title);
				Adzuki.Sidebar.toggleRightSidebar('on');
			} else {
				Adzuki.Sidebar.removeRowSelected();
				Adzuki.Sidebar.setRowSelected($row);
				Adzuki.Sidebar.populateRightContentViaAjax(ajax_path, form_name, title);
				Adzuki.Sidebar.toggleRightSidebar('on');
			}
		});

		// Handle dropdown-links with expand-right-sidebar-ajax class
		$(".dropdown-links").on("change", function dropdownRightSidebarAjax(e) {
			var $selected = $(this).find(':selected');
			var $row      = null;
			var ajax_path = null;
			var form_name = null;

			if ($selected.hasClass('expand-right-sidebar-ajax')) {
				$row      = $(this).closest('.table-row');
				ajax_path = $selected.data('url');
				form_name = $selected.data('form-name') || null;

				e.preventDefault();

				if (Adzuki.Sidebar.currentlySelected($row)) {
					Adzuki.Sidebar.populateRightContentViaAjax(ajax_path, form_name);
					Adzuki.Sidebar.toggleRightSidebar('on');
				} else {
					Adzuki.Sidebar.removeRowSelected();
					Adzuki.Sidebar.setRowSelected($row);
					Adzuki.Sidebar.populateRightContentViaAjax(ajax_path, form_name);
					Adzuki.Sidebar.toggleRightSidebar('on');
				}
			}
		});

		$(".content").on("click", ".expand-right-sidebar-element", function rightSidebarElement(e)
		{
			var $row       = $(this).closest('.table-row'),
			    element_id = $(this).data('element-id'),
			    content    = $('#' + element_id).html() || '',
			    form_name  = $(this).data('form-name') || null;

			e.preventDefault();

			if (!Adzuki.Sidebar.currentlySelected($row)) {
				Adzuki.Sidebar.removeRowSelected();
				Adzuki.Sidebar.setRowSelected($row);
				Adzuki.Sidebar.addContentRight(content, form_name);
				Adzuki.Sidebar.toggleRightSidebar('on');
			}

			if ($(this).data('scrollable')) {
				$rightSidebarContentId.addClass('scrollable');
			} else {
				$rightSidebarContentId.removeClass('scrollable');
			}
		});

		$(".sidebar-right .close-sidebar " + Adzuki.FaIcon.getIconSelectorName('close')).click(function offSidebarToggle(e)
		{
			Adzuki.Sidebar.toggleRightSidebar('off');
		});

		$(".sidebar-collapse-btn").on('click', function collapseSidebar()
		{
			var btn             = $(this),
			    container       = btn.parent(),
			    sidebar_content = container.siblings(".container-fluid"),
			    sidebar         = btn.closest(".sidebar"),
			    sidebar_btns    = sidebar.find("span");

			if (btn.find("span").hasClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'))) {
				sidebar_content.hide();
				sidebar.toggleClass("collapsed");

				if ($('.bottom-panel').length) {
					$('.bottom-panel').css('margin-left', '29px');
				}

				setSidebarCookie("hidden");
			} else {
				sidebar_content.show();
				sidebar.toggleClass("collapsed");

				if ($('.bottom-panel').length) {
					$('.bottom-panel').css('margin-left', '250px');
				}

				setSidebarCookie("opened");
			}

			sidebar_btns.each(function collapseBothButtons()
			{
				var span = $(this);

				if (span.hasClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'))) {
					span.closest("button").attr("title", "Expand Sidebar");
					span.removeClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'));
					span.addClass(Adzuki.FaIcon.getIconStyleName('angle_double_right'));
				} else {
					span.closest("button").attr("title", "Collapse Sidebar");
					span.removeClass(Adzuki.FaIcon.getIconStyleName('angle_double_right'));
					span.addClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'));
				}
			});
		});

		$(".hub-toggle").on('click', function toggleHub()
		{
			var hub              = $(this),
			    hub_key          = hub.data("hub"),
			    hub_menu         = hub.closest(".hub"),
			    hub_menu_links   = hub_menu.find("li"),
			    hub_cookie_index = expanded_hub_menus.indexOf(hub_key);

			if (hub.hasClass("collapsed")) {
				hub.removeClass("collapsed");
				hub.addClass("expanded");

				// add expanded menu to cookie
				if (hub_cookie_index < 0) {
					expanded_hub_menus.push(hub_key);
				}
			} else {
				hub.removeClass("expanded");
				hub.addClass("collapsed");

				// remove collapsed menu from cookie
				if (hub_cookie_index > -1) {
					expanded_hub_menus.splice(hub_cookie_index, 1);
				}
			}

			// set the expanded hub cookie array after expanding/collapsing
			setHubMenusCookie(expanded_hub_menus);

			hub_menu_links.each(function toggleHubLinks()
			{
				var li           = $(this),
					link_hub_key = li.data('section_hub');

				if (link_hub_key === hub_key) {
					if (li.hasClass("hidden")) {
						li.removeClass("hidden");
					} else {
						li.addClass("hidden");
					}
				}
			});
		});

		$(".hub-title-toggle").on('click', function toggleHubTitle()
		{
			var shortcuts_title_toggle       = $(this),
			    shortcuts_title_toggle_state = shortcuts_title_toggle.hasClass("expanded"),
			    shortcuts_left_nav           = $('.my-shortcuts-left-nav');

			if (shortcuts_title_toggle_state) {
				shortcuts_title_toggle.removeClass("expanded");
				shortcuts_title_toggle.addClass("collapsed");
				shortcuts_left_nav.addClass("hidden");
				expanded_my_shortcuts = 0;
			} else {
				shortcuts_title_toggle.removeClass("collapsed");
				shortcuts_title_toggle.addClass("expanded");
				shortcuts_left_nav.removeClass("hidden");
				expanded_my_shortcuts = 1;
			}

			setMyShortcutsCookie(expanded_my_shortcuts);
		});

		checkSidebar();
		checkHubMenus();
		checkMyShortcuts();
	});

	function setSidebarCookie(str)
	{
		Cookies.set('sidebarVisibility', str);
	}

	// grep for sidebar-visibility for all the moving parts
	function checkSidebar()
	{
		var visibility = Cookies.get('sidebarVisibility') || null;

		if (visibility === "hidden") {
			$(".sidebar-collapse-btn").click();

			if ($('.bottom-panel').length) {
				$('.bottom-panel').css('margin-left', '29px');
			}
		}
	}

	function setMyShortcutsCookie(toggle_state)
	{
		var cookie_domain = '.cruiseplannersnet.com';

		if (Adzuki.dev) {
			// on dev, use dev domain
			cookie_domain = '.adzuki.com';
		}

		Cookies.set('my_shortcuts_visibility', toggle_state, {domain: cookie_domain});
	}

	function checkMyShortcuts()
	{
		// my shortcuts are expanded in the code, so toggle if not expanded in cookie
		if (expanded_my_shortcuts === 0) {
			$('.hub-title-toggle').trigger('click');
		}
	}

	function setHubMenusCookie(hubs)
	{
		var cookie_domain = '.cruiseplannersnet.com';

		if (Adzuki.dev) {
			// on dev, use dev domain
			cookie_domain = '.adzuki.com';
		}

		Cookies.set('hub_menus_visibility', hubs, {domain: cookie_domain});

		$expandedHubMenus = hubs;
	}

	// toggle the expanded hubs from cookie
	function checkHubMenus()
	{
		$.each(expanded_hub_menus, function expandedHub(index, hub_key) {
			$('.hub-toggle[data-hub="' + hub_key + '"]:not(.no-auto-expand)').trigger('click');
		});
	}

	/**
	 * Handles the scroll icon section
	 */
	function handleRightSideBarScrollIcon () {
		$(document).on('click', '.sidebar-right-scroll-icon', function handleScrollClick (e) {
			e.preventDefault();
			let sidebar_identifier = $('.sidebar-right-show');
			sidebar_identifier.animate({ scrollTop: sidebar_identifier.scrollTop() + 90});
		});
	}

	Adzuki.Sidebar = Sidebar;
}(jQuery, window.Adzuki || {}));
